import { Injectable } from '@angular/core';
import * as models from '../models/ana-chat.models';
import * as vm from '../models/ana-chat-vm.models';
import * as jsonpath from 'jsonpath';
import { SimulatorFromStudio } from "./plugin.service";
import { Http, Headers, URLSearchParams } from '@angular/http';
import { UtilitiesService } from '../services/utilities.service';
import { IANAChatMessage } from '../models/ana-chat.models';


@Injectable()
export class SampleService {

    private debug: boolean = true;

    constructor() {

    }
    static onMessage(event) {
        //this.logDebug('On message received from studio:');
        //this.logDebug(event.data);
        //console.log("events" + JSON.stringify(event))
        let msg = event as SimulatorMessage;
        if (msg.type == SimulatorMessageType.AnaChatMessage) {
            let cfMsg = (msg as AnaChatSimulatorMessage);
           // console.log("cfMsg" + cfMsg)
            //console.log("handle message received" + this.handleMessageReceived)
            if (this.handleMessageReceived) {
                this.handleMessageReceived(new models.ANAChatMessage(cfMsg.data));

            }

        } else if (msg.type == SimulatorMessageType.AnaChatReset) {
            if (this.handleResetSignal)
                this.handleResetSignal();
        }
    }


    static handleMessageReceived: (message: models.ANAChatMessage) => any;
    static handleResetSignal: () => void;

}

export enum SimulatorMessageType {
    AnaChatMessage = 'AnaChatMessage', AnaChatReset = 'AnaChatReset'
}
export interface SimulatorMessage {
    type: SimulatorMessageType;
    data: any;
}

export interface AnaChatSimulatorMessage extends SimulatorMessage {
    data: IANAChatMessage;
}





// WEBPACK FOOTER //
// D:/NOWFLOATS/ana-web-chat-master-f726fd66c7ed228fb0b4a1e0e71ea760bd266a85/src/app/services/resolver.service.ts